module.exports = __webpack_public_path__ + "static/media/matnrrd_2-1092w.8f788398.png";